export const maritalStatusArray = [
  { code: 'A', display: 'Annulled' },
  { code: 'D', display: 'Divorced' },
  { code: 'I', display: 'Interlocutory' },
  { code: 'L', display: 'Legally Separated' },
  { code: 'M', display: 'Married' },
  { code: 'C', display: 'Common Law' },
  { code: 'P', display: 'Polygamous' },
  { code: 'T', display: 'Domestic partner' },
  { code: 'U', display: 'Unmarried' },
  { code: 'S', display: 'Never Married' },
  { code: 'W', display: 'Widowed' },
  { code: 'UNK', display: 'Unknown' },
  { code: 'NS', display: 'Not Specified' },
];
